import React from 'react';

import Tooltip from 'components/common/Tooltip';
import Vegan from 'components/icons/Vegan';
import EcoFriendly from 'components/icons/EcoFriendly';
import Recycled from 'components/icons/Recycled';
import Organic from 'components/icons/Organic';
import GiveBack from 'components/icons/GiveBack';

import css from 'styles/components/productdetail/productCallout.scss';

const ProductCallout = props => {
  const { attributes } = props;
  const iconsWithLabels = attributes.filter(attribute => iconMap[attribute.value]).map(attribute => {
    const { Icon, label, tooltipText } = iconMap[attribute.value];
    return <li key={label}>
      <Tooltip content={tooltipText}>
        <Icon aria-hidden={true}/>
      </Tooltip>
      <span>{label}</span>
    </li>;
  });
  return <ul aria-label="Product Feature Callout" className={css.productCallout}> { iconsWithLabels } </ul>;
};

export default ProductCallout;

const iconMap = {
  'Vegan' : {
    Icon : Vegan,
    label : 'Vegan',
    tooltipText : '100% cruelty-free products constructed with zero animal parts.'
  },
  'Recycled Material' : {
    Icon : Recycled,
    label : 'Recycled',
    tooltipText : 'Composed of all or parts of materials from recycled goods, such as water bottles.'
  },
  'Sustainably Certified' : {
    Icon : EcoFriendly,
    label : 'Sustainably Certified',
    tooltipText : 'Certified by an industry certifying organization to comply with at least one industry standard for environmental or socioeconomic impact.'
  },
  'Organic' : {
    Icon : Organic,
    label : 'Organic',
    tooltipText : 'Composed of organic cotton and other materials with a lower environmental impact.'
  },
  'Give Back Products' : {
    Icon : GiveBack,
    label : 'Give Back',
    tooltipText : 'Charitable programs where brands make donations in kind or assist with humanitarian projects or organizations.'
  }
};
